import styled from 'styled-components'
import Text from '../components/shared/Text'
import styles from '../utility/styles'
import { GhostError } from '../utility/icons'

const Wrapper = styled.div`
	position: absolute;
	left: ${styles.spacing.navBar};
	top: 0;
	bottom: 0;
	width: ${styles.spacing.chargerScreenSide};
	background-color: ${styles.colors.background};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	@media screen and ${styles.breakpoints.desktop} {
		left: 0;
		top: 64px;
	}
`

const TextRow = styled.div`
    display: flex;
    align-items: center;
`

const Four = styled(Text.Huge)`
    font-size: 240px;
    line-height: 240px;
    margin: 0 100px;
`

export default function NoRouteFound() {
	return (
		<Wrapper>
			<TextRow>
                <Four>4</Four>
                <GhostError />
                <Four>4</Four>
            </TextRow>
            <Text.Heading type='h4'>Weird... This page doesn't exist!</Text.Heading>
		</Wrapper>
	)
}
